import { render } from "../templates/contact-info.html?vue&type=template&id=1df3b6a3&scoped=true"
import script from "./contact-info.vue?vue&type=script&lang=js"
export * from "./contact-info.vue?vue&type=script&lang=js"

import "../styles/contact-info.scss?vue&type=style&index=0&id=1df3b6a3&scoped=true&lang=scss"

import exportComponent from "/var/www/lbr.ru/crm/vue_source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1df3b6a3"]])

export default __exports__